import { sanitizeAlphanumeric } from '@chikara/utils';

export const ALIAS_TAG_MAX_LENGTH = 34;

export function clampMetadataName(value: string): string {
  return sanitizeAlphanumeric(value).slice(0, ALIAS_TAG_MAX_LENGTH);
}
